import React from 'react';
import { TextStyle, Avatar } from '@superops/ui-design-system';
import { useIntl, getTranslatedText } from '@nile/components';

const TechnicianCell = (props) => {
  const intl = useIntl();

  const technicianName =
    props.row?.original?.technician?.name || props?.row?.original?.user?.name;

  return (
    <>
      {technicianName ? (
        <div className="flex ellipsis">
          <div className="mr10">
            <Avatar initials={technicianName?.[0]} size="extraSmall" />
          </div>
          <p className="ellipsis">
            <TextStyle>{technicianName}</TextStyle>
          </p>
        </div>
      ) : (
        <div className="ellipsis">
          <TextStyle variation="subdued">
            {getTranslatedText(intl, 'app.noData.message')}
          </TextStyle>
        </div>
      )}
    </>
  );
};

export default TechnicianCell;
